import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, share, shareReplay } from 'rxjs/operators'

import { environment } from '@env'
import { LazyParams } from '@shared/components/table/table.models'
import { SortingService } from '@core/services/sorting/sorting.service'
import { MatchesService } from '@core/services/matches/matches.service'

import { Provider, Stadium } from './stadium.models'
import { logError } from '@shared/opretators/log-error.operator'
import { Observable } from 'rxjs'

@Injectable()
export class StadiumService {
  readonly #http = inject(HttpClient)
  readonly #sortingService = inject(SortingService)
  readonly #matchesService = inject(MatchesService)

  getStadiums$(params = {}, lazyParams: LazyParams = {} as LazyParams) {
    const paramsBackEnd = {
      filtering: {
        freeText: '',
        ...params,
      },
      ...lazyParams,
    }
    return this.#http
      .post<{
        entities: Stadium[]
        [key: string]: any
      }>(environment.API.SEARCH_STADIUMS, paramsBackEnd)
      .pipe(
        map((data) => ({
          ...data,
          paging: {
            totalRecords: data.entities.length,
            ...data['paging'],
          },
          sorting: {
            ...data['sorting'],
            ...lazyParams.sorting,
          },
          stadiums: this.#sortingService
            .sort(data.entities)
            .map((stadium) => ({ ...stadium, id: stadium.venueId })),
        })),
        share(),
        logError(),
      )
  }

  getStadiumById$(id: string) {
    return this.#http
      .get<Stadium>(`${environment.API.CRUD_STADIUM}/${id}`)
      .pipe(share(), logError())
  }

  updateStadium$(stadium) {
    return this.#http.put<any>(`${environment.API.CRUD_STADIUM}/${stadium.id}`, stadium)
  }

  getMatchesByStadium$(params = {}, lazyParams: LazyParams = {} as LazyParams) {
    return this.#matchesService
      .getMatches$(environment.API.SEARCH_STADIUM_MATCHES, params, lazyParams)
      .pipe(shareReplay(1))
  }

  getProviders() {
    return this.#http.get<Provider[]>(environment.API.STADIUM_STREAMING_PROVIDERS) as Observable<
      any[]
    >
  }
}
